module.exports = __webpack_public_path__ + "img/antes_despues_165.784b9e07.png";